var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 10.2513C7.58366 10.8496 7.09863 11.3346 6.50033 11.3346C5.90202 11.3346 5.41699 10.8496 5.41699 10.2513C5.41699 9.653 5.90202 9.16797 6.50033 9.16797C7.09863 9.16797 7.58366 9.653 7.58366 10.2513Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 13.5013C7.58366 14.0996 7.09863 14.5846 6.50033 14.5846C5.90202 14.5846 5.41699 14.0996 5.41699 13.5013C5.41699 12.903 5.90202 12.418 6.50033 12.418C7.09863 12.418 7.58366 12.903 7.58366 13.5013Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 13.5013C10.8337 14.0996 10.3486 14.5846 9.75033 14.5846C9.15202 14.5846 8.66699 14.0996 8.66699 13.5013C8.66699 12.903 9.15202 12.418 9.75033 12.418C10.3486 12.418 10.8337 12.903 10.8337 13.5013Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 10.2513C10.8337 10.8496 10.3486 11.3346 9.75033 11.3346C9.15202 11.3346 8.66699 10.8496 8.66699 10.2513C8.66699 9.653 9.15202 9.16797 9.75033 9.16797C10.3486 9.16797 10.8337 9.653 10.8337 10.2513Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0837 10.2513C14.0837 10.8496 13.5987 11.3346 13.0003 11.3346C12.402 11.3346 11.917 10.8496 11.917 10.2513C11.917 9.653 12.402 9.16797 13.0003 9.16797C13.5987 9.16797 14.0837 9.653 14.0837 10.2513Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0837 13.5013C14.0837 14.0996 13.5987 14.5846 13.0003 14.5846C12.402 14.5846 11.917 14.0996 11.917 13.5013C11.917 12.903 12.402 12.418 13.0003 12.418C13.5987 12.418 14.0837 12.903 14.0837 13.5013Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 10.2513C17.3337 10.8496 16.8487 11.3346 16.2503 11.3346C15.652 11.3346 15.167 10.8496 15.167 10.2513C15.167 9.653 15.652 9.16797 16.2503 9.16797C16.8487 9.16797 17.3337 9.653 17.3337 10.2513Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 13.5013C17.3337 14.0996 16.8487 14.5846 16.2503 14.5846C15.652 14.5846 15.167 14.0996 15.167 13.5013C15.167 12.903 15.652 12.418 16.2503 12.418C16.8487 12.418 17.3337 12.903 17.3337 13.5013Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5837 10.2513C20.5837 10.8496 20.0987 11.3346 19.5003 11.3346C18.902 11.3346 18.417 10.8496 18.417 10.2513C18.417 9.653 18.902 9.16797 19.5003 9.16797C20.0987 9.16797 20.5837 9.653 20.5837 10.2513Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5837 13.5013C20.5837 14.0996 20.0987 14.5846 19.5003 14.5846C18.902 14.5846 18.417 14.0996 18.417 13.5013C18.417 12.903 18.902 12.418 19.5003 12.418C20.0987 12.418 20.5837 12.903 20.5837 13.5013Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 12.418C2.16699 9.35384 2.16699 7.82178 3.1189 6.86987C4.0708 5.91797 5.60286 5.91797 8.66699 5.91797H17.3337C20.3978 5.91797 21.9298 5.91797 22.8817 6.86987C23.8337 7.82178 23.8337 9.35384 23.8337 12.418V14.5846C23.8337 17.6487 23.8337 19.1808 22.8817 20.1327C21.9298 21.0846 20.3978 21.0846 17.3337 21.0846H8.66699C5.60286 21.0846 4.0708 21.0846 3.1189 20.1327C2.16699 19.1808 2.16699 17.6487 2.16699 14.5846V12.418Z",
    stroke: "white",
    strokeWidth: 1.625
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 17.832H18.4163",
    stroke: "white",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.6946d9bcb39087386814e87f51362607.svg";
export { ForwardRef as ReactComponent };